<template>
<div class="data-ingredient" style="padding: 15px;">
	<el-breadcrumb separator-class="el-icon-arrow-right">
		<el-breadcrumb-item>数据</el-breadcrumb-item>
		<el-breadcrumb-item :to="{ path: '/datacenter/basis/dirsyearlist' }">营养标准</el-breadcrumb-item>
		<el-breadcrumb-item>{{title}}</el-breadcrumb-item>
	</el-breadcrumb>
	<div style="text-align: left; margin-top: 25px;padding-right: 15px;">
		<span style="display: inline-block;margin-right: 80px;">{{title}}</span>
		<span>{{detail}}</span>
		<span style="float:right">
			<span style="color:rgb(167 160 160);">{{enable==1?'启用':'已停用'}}</span>
			<el-switch
				v-model="enable"
				active-color="#13ce66"
				inactive-color="#DCDFE6"
				:active-value="1"
				:inactive-value="0"
				@change="(nval)=>handleChange(nval,id)"
			>
			</el-switch>
			<span style="color:rgb(167 160 160);" v-if="enable==1">注意：如需停用此项，开启其他年份标准即可。</span>
		</span>
	</div>
  <div id="drls" v-loading="loading" element-loading-text="数据加载中...请稍等" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.3)">
    <div class="content_div">
      <div class="table_box">
        <el-table :data="tableData" stripe border style="width:100% !important;" :height="tableHeight">
          <el-table-column prop="name" label="名称" min-width="90px"></el-table-column>
          <el-table-column prop="energy" label="能量" min-width="60px"></el-table-column>
          <el-table-column prop="carbohydrate" label="碳水化合物" min-width="60px"></el-table-column>
          <el-table-column prop="protein" label="蛋白质" min-width="60px"></el-table-column>
          <el-table-column prop="autunite" label="钙" min-width="60px"></el-table-column>
          <el-table-column prop="iron" label="铁" min-width="60px"></el-table-column>
          <el-table-column prop="zicn" label="锌" min-width="60px"></el-table-column>
          <el-table-column prop="a" label="维生素A" min-width="60px"></el-table-column>
          <el-table-column prop="vb1" label="维生素B1" min-width="60px"></el-table-column>
          <el-table-column prop="vb2" label="维生素B2" min-width="60px"></el-table-column>
          <el-table-column prop="c" label="维生素C" min-width="60px"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</div>	
</template>

<script>
import { queryDirsList,updateStatus } from '@/api/basis'
export default {
  data() {
    return {
    	tableData:[],
    	loading:true,
    	boolcheck:false,
			id: null,
			title: null,
			detail: null,
			enable: null,
			tableHeight: window.innerHeight - 105
    };
  },
	created() {
		this.title = this.$route.query.name;
		this.detail = this.$route.query.detail;
		this.enable = parseInt(this.$route.query.enable);
		this.id = this.$route.query.id;
		this.handleQuery(this.id)
	},
  methods: {
    handleQuery(id) {
			queryDirsList(id).then(response=>{
				this.tableData = response.data;
				this.loading = false;
			})
    },
		handleChange(val,id) {
			if(val == 0) {
				this.enable = 1;
			} else {
				updateStatus({id:id,status:val}).then(response=>{
				this.$message.success('状态更改成功');
			})
			}
		}
  }
};
</script>

<style>
#drls {
  width : 98%;
  height: 100%;
}
#drls table{width:100% !important;}
#drls .nav_div {
  padding      : 5px 10px;
  box-sizing   : border-box;
}
#drls .nav_div > span {
  color         : #525352;
  font-size     : 16px;
  font-weight   : 600;
  letter-spacing: 1px;
  margin-right  : 80px;
  line-height   : 35px;
}
#drls .content_div {
  padding: 20px 0 0 0;
}
#drls .content_div #dir_table th,
#drls .content_div #dir_table td {
  text-align: center;
  border    : 1px solid #e6e6e6;
}
#drls .content_div #dir_table .el-table th {
  background-color: #f2f2f2;
}
#drls #dir_table th > div.cell {
  color: #6b6b6b;
}
#drls #dir_table th {
  background-color: #f2f2f2;
}
#drls .content_div .table_box{
	width        : 100%;
	height       : 100%;
	border-bottom: 1px solid #bbbbbb;
}
#drls .el-table td{
	padding: 5px 0;
	font-size: 12px;
}
#drls .el-loading-spinner i,#drls .el-loading-spinner .el-loading-text{
	color: #82ae5c;
}

#drls .nav_right {
	float: right;
	box-sizing: border-box;
	padding-top: 10px;
	color: #607d8b;
}

#drls .nav_right:hover {
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/basis/dirList.vue